import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'aw-public-container',
  templateUrl: './public-container.component.html',
  styleUrls: ['./public-container.component.scss']
})
export class PublicContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
